import React from 'react';
import { Box, RadioGroup, FormControlLabel, Radio, Typography, FormHelperText } from '@mui/material';
import {
  radioGroupStyles,
  radioStyles,
  roleLabelStyles,
  roleMemberCountStyles,
  errorHelperTextStyles_inline,
} from '../../../constants/escalateQueryDialog';

/**
 * EscalationRoleSelector Component
 * Radio group for selecting escalation role
 */
const EscalationRoleSelector = ({ roleOptions, selectedRole, errors, onRoleChange }) => {
  if (roleOptions.length === 0) {
    return null;
  }

  return (
    <>
      <RadioGroup value={selectedRole} onChange={onRoleChange} sx={radioGroupStyles}>
        {roleOptions.map((option) => (
          <FormControlLabel
            key={option.role}
            value={option.role}
            control={<Radio sx={radioStyles} />}
            label={
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography sx={roleLabelStyles}>{option.roleLabel}</Typography>
                <Typography variant="caption" sx={roleMemberCountStyles}>
                  {option.users.length} {option.users.length === 1 ? 'member' : 'members'}
                </Typography>
              </Box>
            }
          />
        ))}
      </RadioGroup>
      {errors.role && (
        <FormHelperText sx={errorHelperTextStyles_inline}>{errors.role}</FormHelperText>
      )}
    </>
  );
};

export default EscalationRoleSelector;
